import { defineComponent as _defineComponent } from 'vue'
import { colors } from '@/constants/theme/colors';
import { LOCALES } from '@/constants/i18n/locales';
import { computed, PropType, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n-composable';
import useStore from '@/utils/store/common';

interface ILocale {
  value: string;
  caption: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfile',
  props: {
  localesAvailable: {
    type: Array as PropType<ILocale[]>,
    default: () => LOCALES
  },
  enabled: {
    type: Boolean
  },
  themeColors: {
    type: Object,
    default: () => colors
  }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;





const i18n = useI18n();

const store = useStore();
const getCurrentUserName = computed(() => store.getters['user/getCurrentUserName']);
const getCurrentUserEmail = computed(() => store.getters['user/getCurrentUserEmail']);

const display = computed(() => props.enabled);

const currentLocale = computed(() => {
  let locale: ILocale = LOCALES[0];
  if (props.localesAvailable) {
    locale = props.localesAvailable.find(lc => lc.value === i18n.locale.value) || LOCALES[0];
  }

  return locale;
});

const locale = ref(currentLocale.value);

watch(
  () => i18n.locale.value,
  () => {
    locale.value = currentLocale.value;
  },
  {
    immediate: true
  }
);

function handleClose() {
  emit('close');
}

async function handleSave() {
  i18n.locale.value = locale.value.value;
  await store.dispatch('user/updateUserLocale', { locale: i18n.locale.value });
  handleClose();
}

return { __sfc: true,props, emit, i18n, store, getCurrentUserName, getCurrentUserEmail, display, currentLocale, locale, handleClose, handleSave }
}

})